module.exports = __webpack_public_path__ + "media/assets/SmallGift-4bebe418c29d012ff138cbc42339d125.svg";